/** Shared layout for informational alerts inside create/edit sheets (safelistings, citations, …). */
export const FORM_SHEET_ALERT_CLASS = "gap-1.5 px-3 py-2.5";

export const FORM_SHEET_ALERT_TITLE_CLASS =
  "line-clamp-none min-h-0 whitespace-normal leading-snug";

export const FORM_SHEET_ALERT_DESCRIPTION_CLASS = "block";
